<template>
  <div>
    <div class="w-full h-full fixed top-0 left-0 -z-10 bg-[#e5e7eb]"></div>
    <Header />
    <div class="bg-[#18469d] p-5 text-white font-bold">
      <ul class="breadcrumb flex">
        <li
          v-for="(item, index) in b_value"
          :key="index"
          :class="{
            'breadcrumb-item': !isActive(index),
            'active-breadcrumb-item': isActive(index),
          }"
        >
          <span class="pl-2" :class="{ 'breadcrumb-text': !isActive(index) }">
            <a :href="item.link">{{ item.text }}</a>
          </span>
          <span v-if="index < b_value.length - 1" class="breadcrumb-arrow">
            >
          </span>
        </li>
      </ul>
    </div>
    <div class="p-5 lg:p-10" >
      <div class="w-full h-full py-5 flex flex-col gap-5">
        <div class="flex justify-between">
          <h1 class="text-lg lg:text-xl font-semibold dark_text">
            Time Table
          </h1>

          <div class="flex flex-col gap-1">
            <p>Date : {{ current_date }}</p>
            <p>Day : {{ current_day }}</p>
          </div>
        </div>
        <div v-if="this.timetablelist.length>0" class="w-full flex flex-col gap-3 mt-10">
          <div class="grid grid-cols-2 lg:flex lg:justify-between  font-bold py-10">
            <p v-if="this.timetablelist[0].program.name" class="">Program: {{this.timetablelist[0].program.name}}</p>
            <p  v-if="this.timetablelist[0].course.name" class="">Course:{{this.timetablelist[0].course.name}}</p>
            <p class="">Semester:{{this.timetablelist[0].semester}}</p>
            <p class="">Section:{{this.timetablelist[0].section}}</p>
          </div>
          <div class="">
            <img :src="timetablelist[0].table_image" alt="" srcset="" class="w-full max-h-[900px] object-fill" />
            <!-- <img src="@/assets/hero.jpg" alt="" srcset="" class="w-full max-h-[900px] object-fill" /> -->
          </div>
        </div>
        <div v-else class="flex justify-center">
          No Data found
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import axios from "axios";
export default {
  data() {
    return {
     timetablelist:[],
      b_value: [],
      current_date: "",
      current_day: "",
      //   loading: true,
    };
  },
  components: {
    Header,
  },
  async created() {
    const today = new Date();
    this.current_date = this.formatDate(today);
    this.current_day = this.getDayName(today);
    this.b_value = [
      { text: "Alliance", link: "/" },
      { text: "Time Table", link: "" },
    ];
    await this.gettimetablelist();
  },
  methods: {
    isActive(index) {
      return index === this.b_value.length - 1;
    },
    gettimetablelist() {
      axios
        .get(
          `${process.env.VUE_APP_API_COMS}/time-table-list/?Key=${localStorage.getItem("LmsId")}`
        )
        .then((resp) => {
         
          if (resp.data.status == 200) {
            this.timetablelist = resp.data.data;
            console.log(" this.timetablelist",  this.timetablelist);
            // setTimeout(() => {
            //   this.loading = false;
            // }, 600);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
    formatDate(date) {
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    },
    getDayName(date) {
      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      return days[date.getDay()];
    },
  },
};
</script>

<style></style>
